import React from 'react'
import { AppBar, Slide, Tab, Tabs, useScrollTrigger } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import GroupsIcon from '@mui/icons-material/Groups';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import BusinessIcon from '@mui/icons-material/Business';
import HouseIcon from '@mui/icons-material/House';
import logo_light from '../assets/images/logo/logo_light.svg';
import logo_nav from '../assets/images/logo/logo_dark.svg';
import useNavActive from '../utils/ScrollHook';

const pages = [
  { name:"Quiénes Somos", icon:<GroupsIcon/>, href:"#home" },
  { name:"Nuestros Servicios", icon:<ElectricalServicesIcon/>, href:"#services",
    // children: [
    //   { name:"Para empresas", icon:<BusinessIcon/>, href:"#business" },
    //   { name:"Para hogares", icon:<HouseIcon/>, href:"#domestic" },
    // ]
  },
  { name:"Contáctanos", icon:<PermContactCalendarIcon/>, href:"#contact_us" },
]
const drawerWidth = 240;

function Header() {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const currNav = useNavActive( pages.map( p => p.href.slice(1) ) );

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const logoName = (logo:string, pLogo?:number) => { return (
    <Box
      component="a"
      className='logo'
      href="#"
      display="block"
      sx={{ p:pLogo }}
    >
      <img src={logo} alt="logo"/>
      <Typography
        variant="h6"
        className='type'
        sx={{ display: { xs: 'none', md: 'flex' } }}
      >
        Electromechanical<br/>
        <small>Consulting & Support</small>
      </Typography>
    </Box>
  )};

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      { logoName(logo_nav, 2) }
      <Divider />
      <List>
        {pages.map((p) => (<>
          <ListItem key={p.name} disableGutters>
          {/* sx={{ pb:p.children?0:''  }} */}
            <ListItemButton component="a" href={p.href}>
              <ListItemIcon>{p.icon}</ListItemIcon>
              <ListItemText primary={p.name} />
            </ListItemButton>
          </ListItem>
          {/* { p.children?
          <List sx={{ pt:0 }}>
            {p.children.map((sp) => 
            <ListItem key={sp.name} disablePadding>
              <ListItemButton component="a" href={sp.href} sx={{ pl:4 }}>
                <ListItemIcon>{sp.icon}</ListItemIcon>
                <ListItemText primary={sp.name} />
              </ListItemButton>
            </ListItem>
            )}
          </List>
          :"" } */}
        </>))}
      </List>
    </Box>
  );

  function HideOnScroll(props:{ children: React.ReactElement}) {
    const trigger = useScrollTrigger({
      target: window ?? undefined,
    });
  
    return (
      <Slide appear={false} direction="down" in={!trigger}>
        {props.children}
      </Slide>
    );
  }

  const container = window !== undefined ? () => window.document.body : undefined;

  return (
    <>
    <HideOnScroll>
      <AppBar component="nav">
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          { logoName(logo_light) }
          <Tabs
            value={currNav}
            aria-label="Lista de Secciones"
            sx={{ display: { xs: 'none', sm: 'block' } }}
            textColor = "inherit"
          >

            {pages.map( (p, i) => (
              <Tab key={ p.name }
                label={ p.name }
                href={ p.href }
                icon={ p.icon }
                iconPosition="start" 
              />
            ))}
          </Tabs>
        </Toolbar>
      </AppBar>
    </HideOnScroll>

      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true, }} // Better open performance on mobile.
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </>
  )
}

export default Header